module.exports = __webpack_public_path__ + "img/logo-white-full.2e0f873.png";